<style lang="scss" scoped>
.header-wraper{
  width:100%;
  height:50px;
  background:rgba(68,132,236,1);
  box-shadow:0px 2px 4px 0px rgba(40,88,164,0.27);
  opacity:0.8443;
  position: fixed;
  z-index: 3;
  left: 0;
  top: 0;
  @media screen and (max-width: 1500px ) {
    height:50px;
  }
  &-logo{
    width: 80px;
    height: 36px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    @media screen and (max-width: 1500px ) {
      width: 80px;
      height: 35px;
    }
  }
  &-button{
    width:62px;
    height:32px;
    background:rgba(255,255,255,1);
    box-shadow:1px 1px 2px 0px rgba(255,255,255,0.5),-1px -1px 2px 0px rgba(66,129,233,0.51);
    border-radius:4px;
    position: absolute;
    right: 0;
    top: 50%;
    margin-right: 5px;
    transform: translateY(-50%);
    font-size:16px;
    font-weight:600;
    color:rgba(67,130,233,1);
    line-height:22px;
    cursor: pointer;
    @media screen and (max-width: 1500px ) {
      width: 62px;
      height: 33px;
      line-height:33px;
      font-size: 16px;
    }
  }
  &-usericon{
    width: 36px;
    height: 36px;
    border-radius: 18px;
    cursor: pointer;
    @media screen and (max-width: 1500px ) {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
  }
}
</style>

<template>
  <div class="header-wraper">
    <div class="wrapper-reset">
      <img class="header-wraper-logo" src="./../assets/img/group3copy.svg" alt="">
      <button class="header-wraper-button"  v-if="!isLogin" @click="$bus.emit('showLoginBox')">登录</button>
      <img class="header-wraper-button header-wraper-usericon" v-else  @click="openUserHome" :src="userIcon" alt="">
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    showNav() {
      this.$bus.emit('showNav');
    },
    openUserHome() {
      window.open(this.userHome);
    },
    GetQueryString(name) {
     let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
     let r = window.location.search.substr(1).match(reg);
     if(r!=null)return  unescape(r[2]); return null;
    }
  },

  data() {
    return{
      isLogin: false,
      userHome: '',
      code: '',
      actId: '',
    }
  },

  mounted() {
    //在登陆失效之后，重置登录信息
    this.$bus.on('resetLogin', () => {
      localStorage.getItem('userIcon') ? this.userIcon = localStorage.getItem('userIcon') : '';
      localStorage.getItem('userHome') ? this.userHome = localStorage.getItem('userHome') : '';
      localStorage.getItem('token') ? this.isLogin = true : this.isLogin = false;
    });
    // 获取url当中的参数 判断是否为客户端中打开的网页 如果是则可以自动登陆
    this.code = this.GetQueryString('code');
    this.actId = 543;
    if(this.code && this.actId){
      this.$http.codeLogin({code: this.code, actId: this.actId}).then((res) => {
        if(res.code === 0){
          localStorage.setItem('token', res.data.accessToken);
          localStorage.setItem('userIcon', res.data.userIcon);
          localStorage.setItem('userHome', res.data.userHome);
          localStorage.setItem('isLogin', 'true');
          this.userIcon = res.data.userIcon;
          this.userHome = res.data.userHome;
          this.isLogin = true;
        } else {
          localStorage.getItem('userIcon') ? this.userIcon = localStorage.getItem('userIcon') : '';
          localStorage.getItem('userHome') ? this.userHome = localStorage.getItem('userHome') : '';
          localStorage.getItem('token') ? this.isLogin = true : this.isLogin = false;
        }
      })
    } else {  // 如果不是则从localstorage中获取登录信息 判断是否为登录状态
      localStorage.getItem('userIcon') ? this.userIcon = localStorage.getItem('userIcon') : '';
      localStorage.getItem('userHome') ? this.userHome = localStorage.getItem('userHome') : '';
      localStorage.getItem('token') ? this.isLogin = true : this.isLogin = false;
    }
    this.$bus.on('userInfo', () => {
      // 这里这样写是因为在login组件中也已经存了localstorage，这里怎么写无所谓了 
      localStorage.getItem('userIcon') ? this.userIcon = localStorage.getItem('userIcon') : '';
      localStorage.getItem('userHome') ? this.userHome = localStorage.getItem('userHome') : '';
      localStorage.getItem('token') ? this.isLogin = true : this.isLogin = false;
    })
  }
}
</script>




// WEBPACK FOOTER //
// src/blocks/Header.vue